/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import Plugins from "./plugins";

let App = {};

App.config = {};

App.getPluginConfig = function(el, name, defaults){
    var config = {};
    var attrName = 'data-'+name;
    defaults = defaults || {};

    if(!el || el.length<=0){
        return {};
    }

    config = el.attr(attrName);

    el.data(attrName, config);
    el.attr(attrName, '');

    if(!config){
        config = {
            plugin: defaults
        };

        return config;
    }

    try{
        let json = $.parseJSON(config);
        config = json;
    }catch(error){}

    if(typeof config!=='object' && config){
        return {plugin: config};
    }

    if(!config || typeof config!=='object'){
        return {plugin: {}};
    }

    if(typeof config.plugin=='undefined'){
        config = {
            plugin: config
        };
    }

    config.plugin = $.extend({}, defaults, config.plugin);

    return config;
};

App.registerPlugins = function(obj){
    $.each(Plugins, function(k,v){
        if(typeof v.init === 'function'){
            v.init(obj);
        }
    });
};

App.registerApp = function(obj){

};

App.init = function(obj){
    App.registerPlugins(obj);
    App.registerApp(obj);
};

App.bootstrap = function(options){
    App.config = options;

    var obj = $('body');

    App.init(obj);
};

App.notify = new function(){
    var me = this;

    this.init = function(){
        var notify = $('<div id="notify-box" class="alerts-box">'+
            '</div>');

        if(!$('body').find('#notify-box').length){
            $('body').append(notify);
        }
    };

    this.open = function(params){
        me.init();

        var options = $.extend({}, {
            'type': 'info',
            'content': '',
            'icon': '',
            'closeAfter': 4000
        }, params);

        if(!options.icon){
            switch(options.type){
                case 'info':
                    options.icon = 'info';
                    break;
                case 'warning':
                    options.icon = 'exclamation';
                    break;
                case 'success':
                    options.icon = 'check';
                    break;
                case 'danger':
                    options.icon = 'ban';
                    break;
            }
        }

        var notify = $(
            '<div class="alert alert-'+options.type+'">'+
            '<div class="alert-body">'+
            '<div class="alert-icon">'+
            '<i class="fa fa-'+options.icon+'"></i>'+
            '</div>'+
            '<div class="alert-content">'+
            options.content+
            '</div>'+
            '</div>'+
            '<div class="alert-close"><i class="fa fa-times"></i></div>'+
            '</div>'
        );

        notify.click(function (){
            me.close($(this));
        });
        notify.find('.alert-close').click(function(){
            me.close($(this).closest('.alert'));
        });

        if(options.closeAfter){
            setTimeout(function(){
                me.close(notify);
            }, options.closeAfter);
        }

        $('#notify-box').append(notify);

        notify.slideDown('fast');
    };

    this.close = function(notify){
        notify.fadeOut(function(){
            notify.remove();
        });
    };
};

App.modal = new function(){
    var me = this;

    this.options = {
        id: 'default',
        size: 'lg',
        content: '',
        plugin: {
            keyboard: true,
            backdrop: true,
            show: false
        },
        closeBtn: true,
        loaderTemplate:
            '<div class="loader spinner-one">'+
            '<div class="rect1"></div>'+
            '<div class="rect2"></div>'+
            '<div class="rect3"></div>'+
            '<div class="rect4"></div>'+
            '<div class="rect5"></div>'+
            '</div>',
    };

    this.ajax = function(url, success, options){
        me.loader(options);

        if(url.indexOf('?')===-1){
            url = url+'?';
        }else{
            url = url+'&';
        }
        url = url+'inModal=1';

        ajaxify.request.get({
            url: url,
            success: function(response){
                if(success) success();

                me.html(response.page.html, options);
            }
        }, {
            updateContainer: null
        });
    };

    this.html = function(html, options){
        var options = $.extend({}, options, {content: html});

        me.open(options);
    };

    this.closeForce = function(modalId){
        var id = '#modal-content-'+(typeof modalId === 'undefined' ? 'default' : modalId);
        var modal = $('body').find(id);

        modal.modal('hide');
        modal.find('.modal-container').empty();
    };

    this.close = function(modalId){
        var id = '#modal-content-'+(typeof modalId === 'undefined' ? 'default' : modalId);
        var modal = $('body').find(id);

        me.closeForce(modalId);
    };

    this.getInstance = function(options){
        var id = '#modal-content-'+options.id;
        var modal = $('body').find(id);
        if(!modal.length){
            modal = $(
                '<div id="'+id.replace('#', '')+'" data-modal-id="'+options.id+'" class="fade modal modal-type-content" role="dialog" tabindex="-1">'+
                '<div class="modal-dialog">'+
                '<div class="modal-content">'+
                '<div class="modal-close"></div>'+
                '<div class="modal-container"></div>'+
                '</div>'+
                '</div>'+
                '</div>'
            );

            $('body').append(modal);

            modal.modal(me.options.plugin);

            modal.on('shown.bs.modal', function() {
                $(document).off('focusin.modal');
            });
            modal.on('hidden.bs.modal', function() {
                if($('.modal.show').length){
                    $('body').addClass('modal-open');
                }
            });
            modal.find('.modal-close').click(function(){
                me.close($(this).closest('.modal').data('modal-id'));
            });
        }

        modal
            .find('.modal-dialog')
            .attr('class', 'modal-dialog')
            .addClass('modal-'+options.size);

        var closeBtn = modal.find('.modal-close');
        if(options.closeBtn){
            closeBtn.css('display', 'flex');
        }else{
            closeBtn.css('display', 'none');
        }

        modal.find('.modal-container').empty().append(options.content);

        return modal;
    };

    this.open = function(options){
        var options = $.extend({}, me.options, options);

        var modal = me.getInstance(options);

        modal.modal('show');
    };

    this.loader = function(options){
        var $loader =
            '<div class="modal-body modal-loading">'+
            me.options.loaderTemplate+
            '</div>';

        var options = $.extend({}, options, {closeBtn: false});

        me.html($loader, options);
    };
};

App.loader = new function($el, $type, $options){
    let $this = this;

    this.config = {
        el: null,
        type: 'block'
    };

    this.start = function(){
        if(!$this.config.el.length){
            return;
        }

        $this.config.el.each(function(){
            let $type = $this.getType($(this));

            $(this)
                .addClass('has-loader')
                .addClass('has-loader-'+$type);

            if(!$(this).find('.loader-container').length){
                $(this).append($this.getLoaderTemplate($type));
            }

            $(this).addClass('is-loading');
        });

    };

    this.endAfter = function($el, $seconds){
        let $me = this;
        setTimeout(function () {
            $me.end($el);
        }, $seconds);
    };

    this.end = function ($el) {
        if(!$el.length){
            return;
        }

        $el.each(function() {
            $(this).removeClass('is-loading');
        });
    };

    this.getType = function ($el) {
        let $type = $this.config.type;

        if(!$type){
            $type = 'block';
            if($el.is('button') || $el.is('a')){
                $type = 'button';
            }
        }

        return $type;
    };

    this.getLoaderTemplate = function ($type) {
        let $loader;

        switch ($type) {
            case 'block':
                $loader = $('<div class="loader-container">' +
                    '   <div class="spinner">\n' +
                    '       <div class="double-bounce1"></div>\n' +
                    '       <div class="double-bounce2"></div>\n' +
                    '   </div>' +
                    '</div>');

                break;
            case 'button':
                $loader = $('<div class="loader-container">' +
                    '   <div class="loader"></div>' +
                    '</div>');

                break;
        }

        return $loader;
    };

    this.init = function($el, $type, $options){
        $this.config = $.extend({}, this.config, $options);
        $this.config.el = $el;
        $this.config.type = $type;

        $this.start();
    };
};

export default App;
